import Vue from 'vue';
import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@/assets/styles/theme.scss';
import 'viewerjs/dist/viewer.css';
import ToggleButton from 'vue-js-toggle-button';
import Notifications from 'vue-notification';
import Viewer from 'v-viewer';
import VueHtml2pdf from 'vue-html2pdf';
import InnerImageZoom from 'vue-inner-image-zoom';
// import {jsPDF} from 'jspdf';
import Toasted from 'vue-toasted';
import vClickOutside from 'v-click-outside';
import VueApexCharts from 'vue-apexcharts';

Vue.use(VueHtml2pdf);
// Vue.use(VueApexCharts);

Vue.use(InnerImageZoom);
Vue.use(Toasted);
Vue.use(ToggleButton);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(Notifications);
Vue.use(Viewer);
Vue.use(vClickOutside);
